import { MarkerWithPopup } from '@streetferret/map-web';
import {
  CardDescription,
  CardHeader,
  CardTitle,
} from '@streetferret/ui-web/card';
import { DateTime } from '@streetferret/ui-web/typography/date-time';

export interface RouteStartEndMarkersProps {
  startDate: Date;

  startPoint?: {
    lat: number;
    lng: number;
  };
  endPoint?: {
    lat: number;
    lng: number;
  };
}
export function RouteStartEndMarkers({
  startDate,
  startPoint,
  endPoint,
}: RouteStartEndMarkersProps) {
  return (
    <>
      {startPoint && <RouteStartMarker {...startPoint} startDate={startDate} />}
      {endPoint && <RouteEndMarker {...endPoint} />}
    </>
  );
}

interface RouteStartMarkerProps {
  lat: number;
  lng: number;
  startDate: Date;
}
/**
 * Marker to show the start of a route or journey.
 */
export function RouteStartMarker({
  lat,
  lng,
  startDate,
}: RouteStartMarkerProps) {
  return (
    <MarkerWithPopup
      lat={lat}
      lng={lng}
      marker={
        <div className="relative size-4 bg-green-500 dark:bg-green-700 border-2 border-foreground rounded-full cursor-pointer" />
      }
      popup={
        <CardHeader className="min-w-[48px]">
          <CardTitle className="text-base">Start</CardTitle>
          <CardDescription>
            <DateTime date={startDate} />
          </CardDescription>
        </CardHeader>
      }
    />
  );
}

interface RouteEndMarkerProps {
  lat: number;
  lng: number;
}

/**
 * Marker to show the end of a route or journey.
 */
export function RouteEndMarker({ lat, lng }: RouteEndMarkerProps) {
  return (
    <MarkerWithPopup
      lat={lat}
      lng={lng}
      marker={
        <div className="relative size-4 cursor-pointer">
          <div className="absolute inset-0 rounded-full border-2 border-white overflow-hidden">
            <div
              className="absolute inset-0 bg-[repeating-conic-gradient(white_0_90deg,theme(colors.muted-foreground)_90deg_180deg)]"
              style={{ backgroundSize: '4px 4px' }}
            />
          </div>
        </div>
      }
      popup={
        <CardHeader className="min-w-[48px]">
          <CardTitle className="text-base">Finish</CardTitle>
        </CardHeader>
      }
    />
  );
}
